import useAsyncData from "../../../hooks/use-async-data";
import passengerService from "../passenger.service";
import PassengerData from "./passenger-data";
import PassengerDataParams from "./passenger-data-params";

const usePassengerData = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<PassengerData | null>(null);

  const load = async (
    params: PassengerDataParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const passengerData = await passengerService.getData(params, signal);

      setData(passengerData);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default usePassengerData;
